import { useRouteInfo } from "../../core/routing/routingHooks";
import Login from "../../login/website/Login";
import PropTypes from "prop-types";
import React, { Component, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

class LoginWrapper extends Component {
  shouldComponentUpdate(nextProps) {
    const route = this.props.route;
    const nextRoute = nextProps.route;

    // Handle null route during initialization
    if (!route || !nextRoute) {
      return true;
    }

    return (
      route.name !== nextRoute.name &&
      (route.name === "login" || nextRoute.name === "login")
    );
  }

  renderChild() {
    return <>{this.props.children}</>;
  }

  render() {
    const { route } = this.props;

    // Handle null route during initialization
    if (!route) {
      return null;
    }

    return route.name === "login" ? <Login /> : this.renderChild();
  }
}

LoginWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

const ConnectedLoginWrapper = connect()(LoginWrapper);

// Wrapper component that provides route via hook and handles auth redirect
const LoginWrapperWithRoute = (props) => {
  const route = useRouteInfo();
  const navigate = useNavigate();
  const location = useLocation();
  const guestAuthenticated = window.__GUEST_AUTHENTICATED__ === "True";

  useEffect(() => {
    // If user is not authenticated and not already on login page, redirect to login
    if (!guestAuthenticated && route.name !== "login") {
      const currentPath = `${location.pathname}${location.search}`;
      navigate(`/login?next=${encodeURIComponent(currentPath)}`, {
        replace: true,
      });
    }

    // If user is authenticated and on login page, redirect to next or home
    if (guestAuthenticated && route.name === "login") {
      const searchParams = new URLSearchParams(location.search);
      const next = searchParams.get("next");
      navigate(next ? decodeURIComponent(next) : "/", { replace: true });
    }
  }, [
    guestAuthenticated,
    route.name,
    location.pathname,
    location.search,
    navigate,
  ]);

  return <ConnectedLoginWrapper {...props} route={route} />;
};

export default LoginWrapperWithRoute;
